import React from 'react';
import { useField } from 'react-final-form';
import { FormattedMessage } from 'react-intl';

import { InputText } from 'common/Form/UI';
import { required } from 'utils/validation';
import FormItem from 'common/Form/components/FormItem';

import { Wrapper } from '../UI';

/** @type {React.FC<undefined>} */
const Name = () => {
  const fieldProps = { subscription: { value: true, error: true, touched: true }, validate: required };
  const { input: lastNameInput, meta: lastNameMeta } = useField('customerInfo.lastName', fieldProps);
  const { input: firstNameInput, meta: firstNameMeta } = useField('customerInfo.firstName', fieldProps);

  return (
    <Wrapper className="contact-form__wrapper">
      <FormItem
        title={<FormattedMessage id="web.lastname" defaultMessage="Last name" />}
        {...lastNameMeta}
        data-cy="input-lastname"
        required
      >
        <InputText {...lastNameInput} />
      </FormItem>
      <FormItem
        title={<FormattedMessage id="web.firstname" defaultMessage="First name" />}
        {...firstNameMeta}
        data-cy="input-firstname"
        required
      >
        <InputText {...firstNameInput} />
      </FormItem>
    </Wrapper>
  );
};

export default Name;
